export default function LocalDevBadge() {
  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div
      data-testid="confirmph-local-dev-badge"
      role="status"
      aria-label="ConfirmPH local development environment"
      className="fixed bottom-2 right-2 z-[10000] pointer-events-none rounded-md border border-emerald-400/70 bg-slate-950/90 px-2.5 py-1 text-[10px] font-bold tracking-[0.14em] text-emerald-300 shadow-lg"
    >
      CONFIRMPH: LOCAL DEV
    </div>
  );
}
